import { get, post, del } from "@/utils/api";

export const BankAPI = {
    connect: async () => {
        return post("/bank/connect");
    },
    delete: async (bankAccountId) => {
        return del(`/bank/account/${bankAccountId}`);
    },
    addAccount: async (params) => {
        return post("/bank/account/add", params);
    },
    accounts: async () => {
        return get("/bank/accounts");
    },
    activeAccounts: async () => {
        return get("/bank/active-accounts");
    },
    reconciliationAccounts: async () => {
        return get("/bank/reconciliation-accounts");
    },
    reconciliationInstitutions: async () => {
        return get("/bank/reconciliation-institutions");
    },
    account: async (bankAccountId) => {
        return get(`/bank/account/${bankAccountId}`);
    },
    institutions: async () => {
        return get("/bank/institutions");
    },
    bindSystemAccount: async (accountId, systemAccountId) => {
        return post(`/bank/account/${accountId}/bind?systemAccountId=${systemAccountId}`);
    },
    changeAutoTransSync: async (accountId, open) => {
        return post(`/bank/account/${accountId}/auto-trans-sync?open=${open}`);
    },
    updateSyncStartDate: async (bankAccountId, startDate) => {
        return post(`/bank/account/${bankAccountId}/sync-start-date?syncStartDate=${startDate}`);
    },
    getAudits: async (params) => {
        return get(`/bank/audit`, params);
    },
    getConnections: async (params) => {
        return get(`/bank/connections`, params);
    },
    retryRemove: async (bankId) => {
        return post(`/bank/connection/${bankId}/retry-remove`);
    },
    connectionAccounts: async (bankId) => {
        return get(`/bank/connection/${bankId}/accounts`);
    }
}

export const ReconciliationAPI = {
    reconcile: async (bankAccountId, params) => {
        return post(`/reconciliation?bankAccountId=${bankAccountId}`, params);
    },
    reconciliations: async (bankAccountId) => {
        return get(`/reconciliation?bankAccountId=${bankAccountId}`);
    },
    pendingTransactions: async (bankAccountId) => {
        return get(`/reconciliation/pending-reconciliation-transaction-count?bankAccountId=${bankAccountId}`);
    },
    get: async (reconciliationId) => {
        return get(`/reconciliation/${reconciliationId}`);
    },
    getTransactions: async (reconciliationId, page) => {
        return get(`/reconciliation/${reconciliationId}/transactions`, { page: page });
    },
    updateStatementDateAndBalance: async (reconciliationId, statementDate, statementBalance) => {
        return post(`/reconciliation/${reconciliationId}/statement-date-balance?statementDate=${statementDate}&statementBalance=${statementBalance}`);
    },
    confirm: async (reconciliationId) => {
        return post(`/reconciliation/${reconciliationId}/confirm`);
    },
    updateTransactionStatus: async (reconciliationId, transactionId, cleared) => {
        return post(`/reconciliation/${reconciliationId}/transaction-reconciliation-status?transactionId=${transactionId}&cleared=${cleared}`);
    }
}
